import { render, staticRenderFns } from "./SalesByProduct.vue?vue&type=template&id=15268c64"
import script from "./SalesByProduct.vue?vue&type=script&lang=js"
export * from "./SalesByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports